// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: inline-block;
  margin: 0 4px 10px;
  position: relative;
}
:host .file {
  display: block;
  width: 120px;
}
:host .file .file-prev {
  background: rgba(93, 173, 224, 0.3);
  color: #fff;
  display: block;
  font-size: 40px;
  padding-top: 100%;
  position: relative;
  width: 100%;
}
:host .file .file-prev .icon {
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
:host .file .file-prev .icon .delete {
  background: rgba(0, 0, 0, 0.1);
  font-size: 20px;
  position: absolute;
  right: 0;
  top: 0;
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out;
}
.rtl :host .file .file-prev .icon .delete {
  left: 0;
  right: auto;
}
:host .file .file-prev .icon .delete:hover {
  background: rgba(255, 255, 255, 0.3);
  color: #f00;
}
:host .file .file-prev .spinner {
  background: inherit;
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
:host .file .file-prev .spinner .fa {
  font-size: inherit;
}
:host .file .file-name {
  display: flex;
  flex-wrap: nowrap;
  font-size: 11px;
  justify-content: flex-end;
  margin-top: 3px;
  white-space: nowrap;
}
.rtl :host .file .file-name {
  justify-content: flex-start;
}
:host .file .file-name .name {
  overflow: hidden;
  text-overflow: ellipsis;
}
:host .file.doc-file .file-prev {
  background: #029acf;
}
:host .file.xlx-file .file-prev {
  background: #469408;
}
:host .file.pdf-file .file-prev {
  background: #d9831f;
}
:host .file.archive-file .file-prev {
  background: #9b479f;
}
:host .file.audio-file .file-prev {
  background: #FF9800;
}
:host .file.video-file .file-prev {
  background: #FF5722;
}
:host .file.image-file .file-prev .icon {
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
}
:host .file.size-small {
  width: 50px;
}
:host .file.size-small .file-prev {
  font-size: 20px;
}
:host .file.size-large {
  width: 180px;
}
:host .file.size-large .file-prev {
  font-size: 60px;
}
:host .file.spinner-file .file-prev .icon {
  visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./src/app/rt-components/file/file.component.scss"],"names":[],"mappings":"AAEA;EACE,qBAAA;EACA,kBAAA;EACA,kBAAA;AADF;AAGE;EACE,cAAA;EACA,YAAA;AADJ;AAGI;EACE,mCAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AADN;AAGM;EACE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AADR;AAGQ;EACE,8BAAA;EACA,eAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,+DACE;AAFZ;AAKU;EACE,OAAA;EACA,WAAA;AAHZ;AAKU;EACE,oCAAA;EACA,WAAA;AAHZ;AAOM;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AALR;AAOQ;EACE,kBAAA;AALV;AASI;EACE,aAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;AAPN;AASM;EACE,2BAAA;AAPR;AASM;EACE,gBAAA;EACA,uBAAA;AAPR;AAWM;EACE,mBAAA;AATR;AAaM;EACE,mBAAA;AAXR;AAeM;EACE,mBAAA;AAbR;AAiBM;EACE,mBAAA;AAfR;AAmBM;EACE,mBAAA;AAjBR;AAqBM;EACE,mBAAA;AAnBR;AAwBQ;EACE,4BAAA;EACA,4BAAA;EACA,sBAAA;AAtBV;AA0BI;EACE,WAAA;AAxBN;AA0BM;EACE,eAAA;AAxBR;AA2BI;EACE,YAAA;AAzBN;AA2BM;EACE,eAAA;AAzBR;AA8BQ;EACE,kBAAA;AA5BV","sourcesContent":["@import '../../../assets/sass/variable';\r\n\r\n:host {\r\n  display: inline-block;\r\n  margin: 0 4px 10px;\r\n  position: relative;\r\n\r\n  .file {\r\n    display: block;\r\n    width: 120px;\r\n\r\n    .file-prev {\r\n      background: rgba(main-color(A100),.3);\r\n      color: #fff;\r\n      display: block;\r\n      font-size: 40px;\r\n      padding-top: 100%;\r\n      position: relative;\r\n      width: 100%;\r\n\r\n      .icon {\r\n        align-items: center;\r\n        display: flex;\r\n        justify-content: center;\r\n        height: 100%;\r\n        left: 0;\r\n        position: absolute;\r\n        top: 0;\r\n        width: 100%;\r\n\r\n        .delete {\r\n          background: rgba(#000,.1);\r\n          font-size: 20px;\r\n          position: absolute;\r\n          right: 0;\r\n          top: 0;\r\n          transition:\r\n            background .2s $animation,\r\n            color .2s $animation;\r\n\r\n          .rtl & {\r\n            left: 0;\r\n            right: auto;\r\n          }\r\n          &:hover {\r\n            background: rgba(#fff,.3);\r\n            color: #f00;\r\n          }\r\n        }\r\n      }\r\n      .spinner {\r\n        background: inherit;\r\n        align-items: center;\r\n        display: flex;\r\n        justify-content: center;\r\n        height: 100%;\r\n        left: 0;\r\n        position: absolute;\r\n        top: 0;\r\n        width: 100%;\r\n\r\n        .fa {\r\n          font-size: inherit;\r\n        }\r\n      }\r\n    }\r\n    .file-name {\r\n      display: flex;\r\n      flex-wrap: nowrap;\r\n      font-size: 11px;\r\n      justify-content: flex-end;\r\n      margin-top: 3px;\r\n      white-space: nowrap;\r\n\r\n      .rtl & {\r\n        justify-content: flex-start;\r\n      }\r\n      .name {\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n      }\r\n    }\r\n    &.doc-file {\r\n      .file-prev {\r\n        background: #029acf;\r\n      }\r\n    }\r\n    &.xlx-file {\r\n      .file-prev {\r\n        background: #469408;\r\n      }\r\n    }\r\n    &.pdf-file {\r\n      .file-prev {\r\n        background: #d9831f;\r\n      }\r\n    }\r\n    &.archive-file {\r\n      .file-prev {\r\n        background: #9b479f;\r\n      }\r\n    }\r\n    &.audio-file {\r\n      .file-prev {\r\n        background: #FF9800;\r\n      }\r\n    }\r\n    &.video-file {\r\n      .file-prev {\r\n        background: #FF5722;\r\n      }\r\n    }\r\n    &.image-file {\r\n      .file-prev {\r\n        .icon {\r\n          background-position: 50% 50%;\r\n          background-repeat: no-repeat;\r\n          background-size: cover;\r\n        }\r\n      }\r\n    }\r\n    &.size-small {\r\n      width: 50px;\r\n\r\n      .file-prev {\r\n        font-size: 20px;\r\n      }\r\n    }\r\n    &.size-large {\r\n      width: 180px;\r\n\r\n      .file-prev {\r\n        font-size: 60px;\r\n      }\r\n    }\r\n    &.spinner-file {\r\n      .file-prev {\r\n        .icon {\r\n          visibility: hidden;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
